const translations = {
  en: {
    nav: {
      home: "Home",
      inventory: "Inventory",
      impressions: "Impressions",
      partners: "Partners",
      about: "About",
      contact: "Contact",
      admin: "Admin",
      login: "Login",
      logout: "Logout",
      dashboard: "Dashboard"
    },
    hero: {
      title: "GLOBAL AUTO EXPORT",
      subtitle: "Premium vehicles sourced worldwide. Delivered anywhere.",
      cta: "View Inventory",
      ctaSecondary: "Contact Us",
      stat1Label: "Vehicles Exported",
      stat1Value: "2,500+",
      stat2Label: "Countries Served",
      stat2Value: "45+",
      stat3Label: "Years Experience",
      stat3Value: "25+"
    },
    inventory: {
      title: "OUR INVENTORY",
      subtitle: "Browse our current selection of premium vehicles ready for export",
      search: "Search by make, model, or stock number...",
      filterMake: "All Makes",
      filterCondition: "All Conditions",
      filterNew: "New",
      filterUsed: "Used",
      noResults: "No vehicles match your criteria",
      price: "Price",
      mileage: "Mileage",
      year: "Year",
      condition: "Condition",
      stockNumber: "Stock #",
      viewDetails: "View Details",
      featured: "Featured",
      clearFilters: "Clear Filters",
      showing: "Showing",
      of: "of",
      vehicles: "vehicles"
    },
    carDetail: {
      backToInventory: "Back to Inventory",
      specifications: "Specifications",
      description: "Description",
      engine: "Engine",
      transmission: "Transmission",
      fuelType: "Fuel Type",
      color: "Color",
      inquire: "Inquire About This Vehicle",
      whatsapp: "WhatsApp Us",
      exportReady: "Export Ready",
      whatsappTemplate: "Hi Partners4Cars, I'm interested in the {vehicle} (Stock: {stock}, Price: {price}). Could you share more details?"
    },
    impressions: {
      title: "OUR WORK",
      subtitle: "A showcase of successful exports and vehicle preparations",
      all: "All",
      export: "Export",
      preparation: "Preparation",
      delivery: "Delivery"
    },
    about: {
      title: "ABOUT PARTNERS4CARS",
      subtitle: "Your trusted partner in global automotive sourcing and export",
      mission: "Our Mission",
      missionText: "At Partners4Cars, we connect buyers worldwide with premium vehicles. With over 25 years of experience in the automotive export industry, we have built a reputation for reliability, quality, and competitive pricing.",
      whyUs: "Why Choose Us",
      reason1Title: "Global Network",
      reason1Text: "Access to premium vehicles from manufacturers and dealers worldwide.",
      reason2Title: "Export Expertise",
      reason2Text: "Enjoy a hassle-free shipping experience. Whether by sea, air, or land, we handle every detail from export documentation to full logistics coordination so your cargo moves smoothly and efficiently.",
      reason3Title: "Quality Assured",
      reason3Text: "Every vehicle undergoes thorough inspection before delivery.",
      reason4Title: "Competitive Pricing",
      reason4Text: "Direct sourcing means better prices with transparent costs."
    },
    contact: {
      title: "GET IN TOUCH",
      subtitle: "Ready to find your next vehicle? Contact our team today.",
      name: "Full Name",
      email: "Email Address",
      phone: "Phone Number",
      subject: "Subject",
      message: "Your Message",
      send: "Send Message",
      sending: "Sending...",
      success: "Message sent successfully! We'll get back to you soon.",
      error: "Failed to send message. Please try again.",
      whatsappCta: "Quick response via WhatsApp",
      info: "Contact Information",
      address: "The Netherlands",
      emailAddress: "sales@partners4cars.com",
      phoneNumber: "+31 6 25025292"
    },
    footer: {
      rights: "All rights reserved.",
      tagline: "Premium Vehicle Export Worldwide"
    },
    admin: {
      login: "Admin Login",
      username: "Username",
      password: "Password",
      signIn: "Sign In",
      dashboard: "Dashboard",
      totalCars: "Total Vehicles",
      totalImpressions: "Impressions",
      totalContacts: "Messages",
      unreadContacts: "Unread",
      manageCars: "Manage Vehicles",
      manageImpressions: "Manage Impressions",
      viewMessages: "Messages",
      addCar: "Add Vehicle",
      editCar: "Edit Vehicle",
      deleteCar: "Delete",
      addImpression: "Add Impression",
      save: "Save",
      cancel: "Cancel",
      confirm: "Are you sure?",
      noData: "No data yet"
    },
    partners: {
      title: "OUR PARTNERS",
      subtitle: "Explore our family of companies and their offerings",
      p4hTitle: "Partners4Horses",
      p4hDescription: "Your trusted partner for premium horses and equestrian equipment. From top-quality horses to professional trailers and accessories.",
      horses: "Horses",
      trailers: "Trailers",
      equipment: "Equipment",
      all: "All",
      viewDetails: "View Details",
      name: "Name",
      breed: "Breed",
      age: "Age",
      gender: "Gender",
      price: "Price",
      noResults: "No items available at the moment"
    },
    wholesale: {
      eyebrow: "Partners4Cars",
      title: "Why Choose Partners4Cars as Your Global Automotive Wholesale Partner",
      p1: "At Partners4Cars, we connect automotive businesses worldwide with a reliable and diverse supply of premium vehicles. We work closely with dealerships, traders, and industry professionals, providing seamless access to international inventory through a trusted global network.",
      p2: "Our approach is built on efficiency, transparency, and speed. By streamlining the sourcing and distribution process, we enable our partners to secure high-quality vehicles quickly and with confidence. Whether you are looking to expand your inventory or enter new markets, we ensure consistent availability and competitive opportunities.",
      p3: "With deep market knowledge and a strong international presence, Partners4Cars acts as a dependable link between supply and demand in the global automotive trade.",
      ctaInventory: "View Inventory",
      ctaContact: "Contact Us",
      feature1Title: "Global Network",
      feature1Desc: "Access to premium vehicles from manufacturers and dealers worldwide",
      feature2Title: "Fast & Efficient",
      feature2Desc: "Streamlined sourcing and distribution for quick turnaround",
      feature3Title: "Trusted Partner",
      feature3Desc: "Built on transparency, reliability, and long-term relationships"
    },
    experience: {
      eyebrow: "Our Track Record",
      title: "Over 25 Years of Experience You Can Rely On",
      p1: "With more than 25 years of experience in the automotive export industry, Partners4Cars has established a strong reputation for reliability, quality, and competitive pricing. Our long-standing presence in the market allows us to anticipate trends, respond quickly to demand, and consistently deliver value to our partners.",
      p2: "Through our extensive global network of manufacturers, dealers, and logistics partners, we provide access to a wide selection of carefully sourced vehicles. Over the years, we have successfully delivered thousands of vehicles to clients in more than 45 countries worldwide.",
      closing: "Our experience and commitment to long-term partnerships make us a reliable choice for automotive professionals around the world.",
      ctaAbout: "About Us",
      stat1Value: "25+",
      stat1Label: "Years of Industry Experience",
      stat2Value: "2,500+",
      stat2Label: "Vehicles Delivered",
      stat3Value: "45+",
      stat3Label: "Countries Served",
      stat4Value: "100%",
      stat4Label: "Trusted Partner Network",
      bullet1: "25+ years of industry experience",
      bullet2: "2,500+ vehicles delivered",
      bullet3: "Active in 45+ countries",
      bullet4: "Trusted international partner network"
    }
  },
  es: {
    nav: {
      home: "Inicio",
      inventory: "Inventario",
      impressions: "Impresiones",
      partners: "Socios",
      about: "Nosotros",
      contact: "Contacto",
      admin: "Admin",
      login: "Iniciar sesion",
      logout: "Cerrar sesion",
      dashboard: "Panel"
    },
    hero: {
      title: "EXPORTACION GLOBAL DE AUTOS",
      subtitle: "Vehiculos premium de todo el mundo. Entregados en cualquier lugar.",
      cta: "Ver Inventario",
      ctaSecondary: "Contactenos",
      stat1Label: "Vehiculos Exportados",
      stat1Value: "2,500+",
      stat2Label: "Paises Atendidos",
      stat2Value: "45+",
      stat3Label: "Anos de Experiencia",
      stat3Value: "25+"
    },
    inventory: {
      title: "NUESTRO INVENTARIO",
      subtitle: "Explore nuestra seleccion de vehiculos premium listos para exportar",
      search: "Buscar por marca, modelo o numero de stock...",
      filterMake: "Todas las Marcas",
      filterCondition: "Todas las Condiciones",
      filterNew: "Nuevo",
      filterUsed: "Usado",
      noResults: "No hay vehiculos que coincidan",
      price: "Precio",
      mileage: "Kilometraje",
      year: "Ano",
      condition: "Condicion",
      stockNumber: "Stock #",
      viewDetails: "Ver Detalles",
      featured: "Destacado",
      clearFilters: "Limpiar Filtros",
      showing: "Mostrando",
      of: "de",
      vehicles: "vehiculos"
    },
    carDetail: {
      backToInventory: "Volver al Inventario",
      specifications: "Especificaciones",
      description: "Descripcion",
      engine: "Motor",
      transmission: "Transmision",
      fuelType: "Tipo de Combustible",
      color: "Color",
      inquire: "Consultar Sobre Este Vehiculo",
      whatsapp: "WhatsApp",
      exportReady: "Listo para Exportar",
      whatsappTemplate: "Hola Partners4Cars, me interesa el {vehicle} (Stock: {stock}, Precio: {price}). Podria compartir mas detalles?"
    },
    impressions: {
      title: "NUESTRO TRABAJO",
      subtitle: "Una muestra de exportaciones exitosas y preparaciones de vehiculos",
      all: "Todos",
      export: "Exportacion",
      preparation: "Preparacion",
      delivery: "Entrega"
    },
    about: {
      title: "SOBRE PARTNERS4CARS",
      subtitle: "Su socio de confianza en la busqueda y exportacion automotriz global",
      mission: "Nuestra Mision",
      missionText: "En Partners4Cars, conectamos compradores de todo el mundo con vehiculos premium. Con mas de 25 anos de experiencia en la industria de exportacion automotriz, hemos construido una reputacion de confiabilidad, calidad y precios competitivos.",
      whyUs: "Por Que Elegirnos",
      reason1Title: "Red Global",
      reason1Text: "Acceso a vehiculos premium de fabricantes y distribuidores en todo el mundo.",
      reason2Title: "Experiencia en Exportacion",
      reason2Text: "Disfrute de una experiencia de envio sin complicaciones. Ya sea por mar, aire o tierra, nos encargamos de cada detalle, desde la documentacion de exportacion hasta la coordinacion logistica completa, para que su carga se mueva de manera fluida y eficiente.",
      reason3Title: "Calidad Garantizada",
      reason3Text: "Cada vehiculo pasa por una inspeccion exhaustiva antes de la entrega.",
      reason4Title: "Precios Competitivos",
      reason4Text: "La compra directa significa mejores precios con costos transparentes."
    },
    contact: {
      title: "CONTACTENOS",
      subtitle: "Listo para encontrar su proximo vehiculo? Contacte a nuestro equipo hoy.",
      name: "Nombre Completo",
      email: "Correo Electronico",
      phone: "Telefono",
      subject: "Asunto",
      message: "Su Mensaje",
      send: "Enviar Mensaje",
      sending: "Enviando...",
      success: "Mensaje enviado con exito! Nos pondremos en contacto pronto.",
      error: "Error al enviar el mensaje. Intente de nuevo.",
      whatsappCta: "Respuesta rapida por WhatsApp",
      info: "Informacion de Contacto",
      address: "Paises Bajos",
      emailAddress: "sales@partners4cars.com",
      phoneNumber: "+31 6 25025292"
    },
    footer: {
      rights: "Todos los derechos reservados.",
      tagline: "Exportacion de Vehiculos Premium en Todo el Mundo"
    },
    admin: {
      login: "Iniciar Sesion Admin",
      username: "Usuario",
      password: "Contrasena",
      signIn: "Iniciar Sesion",
      dashboard: "Panel de Control",
      totalCars: "Total Vehiculos",
      totalImpressions: "Impresiones",
      totalContacts: "Mensajes",
      unreadContacts: "No Leidos",
      manageCars: "Gestionar Vehiculos",
      manageImpressions: "Gestionar Impresiones",
      viewMessages: "Mensajes",
      addCar: "Agregar Vehiculo",
      editCar: "Editar Vehiculo",
      deleteCar: "Eliminar",
      addImpression: "Agregar Impresion",
      save: "Guardar",
      cancel: "Cancelar",
      confirm: "Esta seguro?",
      noData: "Sin datos"
    },
    partners: {
      title: "NUESTROS SOCIOS",
      subtitle: "Explore nuestra familia de empresas y sus ofertas",
      p4hTitle: "Partners4Horses",
      p4hDescription: "Su socio de confianza para caballos premium y equipamiento ecuestre. Desde caballos de alta calidad hasta remolques y accesorios profesionales.",
      horses: "Caballos",
      trailers: "Remolques",
      equipment: "Equipamiento",
      all: "Todos",
      viewDetails: "Ver Detalles",
      name: "Nombre",
      breed: "Raza",
      age: "Edad",
      gender: "Genero",
      price: "Precio",
      noResults: "No hay articulos disponibles en este momento"
    },
    wholesale: {
      eyebrow: "Partners4Cars",
      title: "Por Que Elegir Partners4Cars como Su Socio Mayorista Automotriz Global",
      p1: "En Partners4Cars, conectamos empresas automotrices de todo el mundo con un suministro confiable y diverso de vehiculos premium. Trabajamos estrechamente con concesionarios, comerciantes y profesionales de la industria, brindando acceso fluido al inventario internacional a traves de una red global de confianza.",
      p2: "Nuestro enfoque se basa en la eficiencia, la transparencia y la velocidad. Al optimizar el proceso de abastecimiento y distribucion, permitimos a nuestros socios asegurar vehiculos de alta calidad rapidamente y con confianza. Ya sea que busque ampliar su inventario o ingresar a nuevos mercados, garantizamos disponibilidad constante y oportunidades competitivas.",
      p3: "Con un profundo conocimiento del mercado y una solida presencia internacional, Partners4Cars actua como un enlace confiable entre la oferta y la demanda en el comercio automotriz global.",
      ctaInventory: "Ver Inventario",
      ctaContact: "Contactenos",
      feature1Title: "Red Global",
      feature1Desc: "Acceso a vehiculos premium de fabricantes y concesionarios en todo el mundo",
      feature2Title: "Rapido y Eficiente",
      feature2Desc: "Abastecimiento y distribucion optimizados para una entrega rapida",
      feature3Title: "Socio Confiable",
      feature3Desc: "Construido sobre transparencia, confiabilidad y relaciones a largo plazo"
    },
    experience: {
      eyebrow: "Nuestra Trayectoria",
      title: "Mas de 25 Anos de Experiencia en los que Puede Confiar",
      p1: "Con mas de 25 anos de experiencia en la industria de exportacion automotriz, Partners4Cars ha establecido una solida reputacion de confiabilidad, calidad y precios competitivos. Nuestra larga presencia en el mercado nos permite anticipar tendencias, responder rapidamente a la demanda y entregar valor constante a nuestros socios.",
      p2: "A traves de nuestra extensa red global de fabricantes, concesionarios y socios logisticos, ofrecemos acceso a una amplia seleccion de vehiculos cuidadosamente seleccionados. A lo largo de los anos, hemos entregado con exito miles de vehiculos a clientes en mas de 45 paises en todo el mundo.",
      closing: "Nuestra experiencia y compromiso con asociaciones a largo plazo nos convierten en una opcion confiable para profesionales automotrices en todo el mundo.",
      ctaAbout: "Sobre Nosotros",
      stat1Value: "25+",
      stat1Label: "Anos de Experiencia en la Industria",
      stat2Value: "2,500+",
      stat2Label: "Vehiculos Entregados",
      stat3Value: "45+",
      stat3Label: "Paises Atendidos",
      stat4Value: "100%",
      stat4Label: "Red de Socios Confiables",
      bullet1: "Mas de 25 anos de experiencia en la industria",
      bullet2: "Mas de 2,500 vehiculos entregados",
      bullet3: "Activos en mas de 45 paises",
      bullet4: "Red internacional de socios confiables"
    }
  },
  de: {
    nav: {
      home: "Startseite",
      inventory: "Bestand",
      impressions: "Impressionen",
      partners: "Partner",
      about: "Ueber Uns",
      contact: "Kontakt",
      admin: "Admin",
      login: "Anmelden",
      logout: "Abmelden",
      dashboard: "Dashboard"
    },
    hero: {
      title: "GLOBALER AUTO-EXPORT",
      subtitle: "Premium-Fahrzeuge weltweit beschafft. Ueberall geliefert.",
      cta: "Bestand Ansehen",
      ctaSecondary: "Kontaktieren Sie Uns",
      stat1Label: "Exportierte Fahrzeuge",
      stat1Value: "2.500+",
      stat2Label: "Bediente Laender",
      stat2Value: "45+",
      stat3Label: "Jahre Erfahrung",
      stat3Value: "25+"
    },
    inventory: {
      title: "UNSER BESTAND",
      subtitle: "Durchsuchen Sie unsere aktuelle Auswahl an Premium-Fahrzeugen fuer den Export",
      search: "Suche nach Marke, Modell oder Bestandsnummer...",
      filterMake: "Alle Marken",
      filterCondition: "Alle Zustaende",
      filterNew: "Neu",
      filterUsed: "Gebraucht",
      noResults: "Keine passenden Fahrzeuge gefunden",
      price: "Preis",
      mileage: "Kilometerstand",
      year: "Baujahr",
      condition: "Zustand",
      stockNumber: "Bestand #",
      viewDetails: "Details Ansehen",
      featured: "Empfohlen",
      clearFilters: "Filter Loeschen",
      showing: "Zeige",
      of: "von",
      vehicles: "Fahrzeugen"
    },
    carDetail: {
      backToInventory: "Zurueck zum Bestand",
      specifications: "Spezifikationen",
      description: "Beschreibung",
      engine: "Motor",
      transmission: "Getriebe",
      fuelType: "Kraftstoffart",
      color: "Farbe",
      inquire: "Anfrage zu Diesem Fahrzeug",
      whatsapp: "WhatsApp",
      exportReady: "Exportbereit",
      whatsappTemplate: "Hallo Partners4Cars, ich interessiere mich fuer den {vehicle} (Bestand: {stock}, Preis: {price}). Koennten Sie weitere Details mitteilen?"
    },
    impressions: {
      title: "UNSERE ARBEIT",
      subtitle: "Eine Auswahl erfolgreicher Exporte und Fahrzeugvorbereitungen",
      all: "Alle",
      export: "Export",
      preparation: "Vorbereitung",
      delivery: "Lieferung"
    },
    about: {
      title: "UEBER PARTNERS4CARS",
      subtitle: "Ihr vertrauenswuerdiger Partner fuer globale Fahrzeugbeschaffung und Export",
      mission: "Unsere Mission",
      missionText: "Bei Partners4Cars verbinden wir Kaeufer weltweit mit Premium-Fahrzeugen. Mit ueber 25 Jahren Erfahrung in der Automobil-Exportbranche haben wir einen Ruf fuer Zuverlaessigkeit, Qualitaet und wettbewerbsfaehige Preise aufgebaut.",
      whyUs: "Warum Uns Waehlen",
      reason1Title: "Globales Netzwerk",
      reason1Text: "Zugang zu Premium-Fahrzeugen von Herstellern und Haendlern weltweit.",
      reason2Title: "Export-Expertise",
      reason2Text: "Geniessen Sie ein sorgenfreies Versanderlebnis. Ob per See, Luft oder Land — wir kuemmern uns um jedes Detail, von der Exportdokumentation bis zur vollstaendigen Logistikkoordination, damit Ihre Fracht reibungslos und effizient transportiert wird.",
      reason3Title: "Qualitaetsgarantie",
      reason3Text: "Jedes Fahrzeug wird vor der Lieferung gruendlich geprueft.",
      reason4Title: "Wettbewerbsfaehige Preise",
      reason4Text: "Direktbeschaffung bedeutet bessere Preise mit transparenten Kosten."
    },
    contact: {
      title: "KONTAKTIEREN SIE UNS",
      subtitle: "Bereit, Ihr naechstes Fahrzeug zu finden? Kontaktieren Sie unser Team.",
      name: "Vollstaendiger Name",
      email: "E-Mail-Adresse",
      phone: "Telefonnummer",
      subject: "Betreff",
      message: "Ihre Nachricht",
      send: "Nachricht Senden",
      sending: "Wird gesendet...",
      success: "Nachricht erfolgreich gesendet! Wir melden uns bald.",
      error: "Fehler beim Senden. Bitte versuchen Sie es erneut.",
      whatsappCta: "Schnelle Antwort ueber WhatsApp",
      info: "Kontaktinformationen",
      address: "Niederlande",
      emailAddress: "sales@partners4cars.com",
      phoneNumber: "+31 6 25025292"
    },
    footer: {
      rights: "Alle Rechte vorbehalten.",
      tagline: "Premium-Fahrzeugexport Weltweit"
    },
    admin: {
      login: "Admin-Anmeldung",
      username: "Benutzername",
      password: "Passwort",
      signIn: "Anmelden",
      dashboard: "Dashboard",
      totalCars: "Gesamtfahrzeuge",
      totalImpressions: "Impressionen",
      totalContacts: "Nachrichten",
      unreadContacts: "Ungelesen",
      manageCars: "Fahrzeuge Verwalten",
      manageImpressions: "Impressionen Verwalten",
      viewMessages: "Nachrichten",
      addCar: "Fahrzeug Hinzufuegen",
      editCar: "Fahrzeug Bearbeiten",
      deleteCar: "Loeschen",
      addImpression: "Impression Hinzufuegen",
      save: "Speichern",
      cancel: "Abbrechen",
      confirm: "Sind Sie sicher?",
      noData: "Keine Daten"
    },
    partners: {
      title: "UNSERE PARTNER",
      subtitle: "Entdecken Sie unsere Unternehmensfamilie und ihre Angebote",
      p4hTitle: "Partners4Horses",
      p4hDescription: "Ihr vertrauenswuerdiger Partner fuer Premium-Pferde und Reitausruestung. Von erstklassigen Pferden bis hin zu professionellen Anhaengern und Zubehoer.",
      horses: "Pferde",
      trailers: "Anhaenger",
      equipment: "Ausruestung",
      all: "Alle",
      viewDetails: "Details Ansehen",
      name: "Name",
      breed: "Rasse",
      age: "Alter",
      gender: "Geschlecht",
      price: "Preis",
      noResults: "Derzeit keine Artikel verfuegbar"
    },
    wholesale: {
      eyebrow: "Partners4Cars",
      title: "Warum Partners4Cars als Ihr Globaler Automobil-Grosshandelspartner",
      p1: "Bei Partners4Cars vernetzen wir Automobilunternehmen weltweit mit einem zuverlaessigen und vielfaeltigen Angebot an Premium-Fahrzeugen. Wir arbeiten eng mit Haendlern, Grosshaendlern und Branchenprofis zusammen und bieten nahtlosen Zugang zu internationalem Bestand ueber ein vertrauenswuerdiges globales Netzwerk.",
      p2: "Unser Ansatz basiert auf Effizienz, Transparenz und Geschwindigkeit. Durch die Optimierung des Beschaffungs- und Vertriebsprozesses ermoeglichen wir unseren Partnern, hochwertige Fahrzeuge schnell und mit Vertrauen zu sichern. Ob Sie Ihren Bestand erweitern oder neue Maerkte erschliessen moechten, wir gewaehrleisten konstante Verfuegbarkeit und wettbewerbsfaehige Moeglichkeiten.",
      p3: "Mit tiefgreifender Marktkenntnis und einer starken internationalen Praesenz fungiert Partners4Cars als zuverlaessiges Bindeglied zwischen Angebot und Nachfrage im globalen Automobilhandel.",
      ctaInventory: "Bestand Ansehen",
      ctaContact: "Kontaktieren Sie Uns",
      feature1Title: "Globales Netzwerk",
      feature1Desc: "Zugang zu Premium-Fahrzeugen von Herstellern und Haendlern weltweit",
      feature2Title: "Schnell & Effizient",
      feature2Desc: "Optimierte Beschaffung und Verteilung fuer eine schnelle Abwicklung",
      feature3Title: "Vertrauenswuerdiger Partner",
      feature3Desc: "Aufgebaut auf Transparenz, Zuverlaessigkeit und langfristigen Beziehungen"
    },
    experience: {
      eyebrow: "Unsere Erfolgsbilanz",
      title: "Ueber 25 Jahre Erfahrung, auf die Sie Sich Verlassen Koennen",
      p1: "Mit mehr als 25 Jahren Erfahrung in der Automobil-Exportbranche hat sich Partners4Cars einen starken Ruf fuer Zuverlaessigkeit, Qualitaet und wettbewerbsfaehige Preise aufgebaut. Unsere langjaehrige Marktpraesenz ermoeglicht es uns, Trends zu antizipieren, schnell auf Nachfrage zu reagieren und unseren Partnern konstant Mehrwert zu liefern.",
      p2: "Durch unser umfangreiches globales Netzwerk aus Herstellern, Haendlern und Logistikpartnern bieten wir Zugang zu einer breiten Auswahl sorgfaeltig beschaffter Fahrzeuge. Im Laufe der Jahre haben wir erfolgreich Tausende von Fahrzeugen an Kunden in mehr als 45 Laendern weltweit geliefert.",
      closing: "Unsere Erfahrung und unser Engagement fuer langfristige Partnerschaften machen uns zu einer zuverlaessigen Wahl fuer Automobilprofis auf der ganzen Welt.",
      ctaAbout: "Ueber Uns",
      stat1Value: "25+",
      stat1Label: "Jahre Branchenerfahrung",
      stat2Value: "2.500+",
      stat2Label: "Fahrzeuge Geliefert",
      stat3Value: "45+",
      stat3Label: "Bediente Laender",
      stat4Value: "100%",
      stat4Label: "Vertrauenswuerdiges Partnernetzwerk",
      bullet1: "25+ Jahre Branchenerfahrung",
      bullet2: "2.500+ gelieferte Fahrzeuge",
      bullet3: "Aktiv in mehr als 45 Laendern",
      bullet4: "Vertrauenswuerdiges internationales Partnernetzwerk"
    }
  }
};

export default translations;
